import axios from "axios";
import {_} from "../utils.js";
import Loading from "./loading.js";
import successMessageContainer from '../templates/success.js'
import errorMessageContainer from '../templates/error.js'
import Validate from "./validate.js";

export default class CmRenewalForm {
    constructor(el) {
        this.form = el
        this.form.addEventListener('submit', this.onSubmit)
        this.pristine = new Validate(this.form)
        this.responseContainer = this.form.querySelector(
            _('response-container', 'element').str(),
        )
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.showLoading()
        const valid = this.pristine.validate()
        if (!valid) {
            this.handleError(
                {
                    error: "Please check if you've entered everything correctly",
                },
            )
            return false
        }

        axios({
            method: 'post',
            url: this.form.dataset.endpoint,
            data: new FormData(this.form),
        })
            .then((response) => {
                this.hideLoading()
                if (response.status !== 200) {
                    return this.handleError(response)
                }
                return this.handleSuccess(response)
            })
            .catch((err) => {
                this.hideLoading()
                if (err.response && err.response.data) {
                    this.handleError(err.response.data)
                    // uncomment to fake a semi success
                    // this.handleError(this.fakeSemiError)
                } else {
                    this.handleError(err)
                }
            })
    }

    showLoading = () => {
        const modal = document.getElementById('update-details-modal-body')
        window.scrollTop = 0
        modal.scrollTop = 0
        this.responseContainer.innerHTML =
            '<div class="form__loading loading" style="height: 250%" data-behaviour="loading"></div>'
        _('loading')
            .nodes()
            .map((el) => new Loading(el))
    }

    hideLoading = () => {
        this.responseContainer.innerHTML = ''
    }

    handleSuccess(response) {
        if (response.data.message) {
            const closeMessage = '<button id="closeSuccessMessage" class="button button--cornflower">Close message</button>'
            this.responseContainer.innerHTML =
                '<div class="form__loading loading" style="height: 250%">'
                + successMessageContainer(response.data.message + '<br>' + closeMessage, 'alert--inline')
                + '</div>'

            document.getElementById('closeSuccessMessage').addEventListener('click', this.hideLoading)
        }
    }

    closeModal = () => {
        const url = new URL(window.location)
        const params = new URLSearchParams(url.search)
        params.delete('modal')
        window.history.pushState(
            null,
            null,
            `${window.location.pathname}${params}${window.location.hash}`,
        )
    }

    handleError(err) {
        if (err.error) {
            const closeMessage = '<button id="closeErrorMessage" class="button button--cornflower">Close message</button>'
            this.responseContainer.innerHTML =
                '<div class="form__loading loading" style="height: 250%">'
                + errorMessageContainer(err.error + '<br>' + closeMessage, 'alert--inline')
                + '</div>'

            document.getElementById('closeErrorMessage').addEventListener('click', this.hideLoading)
        }
    }
}
